module.exports = __webpack_public_path__ + "img/edit-selected.c3a657d3.svg";